var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"audio",staticClass:"audio",attrs:{"controls":"controls","src":_vm.sound}})}
var staticRenderFns = []

export { render, staticRenderFns }